module.exports = __webpack_public_path__ + "static/media/icon-5.40990c98.svg";